"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVaporPressure = void 0;
const deepmerge_1 = __importDefault(require("deepmerge"));
const physical_parser_1 = require("physical-parser");
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 * Returns the vapor pressure of a compound
 * @param data Data of a compound data request to the PubChem API
 * @param options Options for the compound
 */
function getVaporPressure(data, options = {}) {
    const vaporPressure = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Vapor Pressure', {
        parser: (value) => (0, physical_parser_1.parseVaporPressure)(value, (0, deepmerge_1.default)({
            temperature: { optional: true },
        }, options)),
    });
    return vaporPressure;
}
exports.getVaporPressure = getVaporPressure;
//# sourceMappingURL=getVaporPressure.js.map